module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjEwIiB2aWV3Qm94PSIwIDAgNiAxMCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgc3Ryb2tlPSIjMjkyNjI1IiBzdHJva2Utd2lkdGg9IjEuNiI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0zNDQgMTE4TDM0MCAxMjIgMzQ0IDEyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzOSAtMTE3KSByb3RhdGUoLTE4MCAzNDIgMTIyKSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/arrow_right.svg
// module id = id+4
// module chunks = 30